var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecruitmenthome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_126_237)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7272 39.9766H10.3569C8.92751 39.9766 7.7793 38.8049 7.7793 37.3989V11.2009C7.7793 11.0603 7.82616 10.9197 7.94333 10.826C8.03706 10.7088 8.17766 10.662 8.34169 10.662C8.41199 10.662 8.48228 10.662 8.55258 10.662C11.1771 10.662 13.3329 8.52958 13.3329 5.88166C13.3329 4.96778 13.0751 4.07733 12.583 3.32747C12.4659 3.16344 12.4659 2.95255 12.5596 2.76508C12.6533 2.60105 12.8408 2.48389 13.0517 2.48389H34.7272C36.1566 2.48389 37.3048 3.6321 37.3048 5.06151V37.3755C37.3048 38.8049 36.1566 39.9766 34.7272 39.9766ZM8.85721 11.7633V37.3989C8.85721 38.2191 9.53677 38.8752 10.3569 38.8752H34.7272C35.5473 38.8752 36.2269 38.2191 36.2269 37.3989V5.06151C36.2269 4.24136 35.5473 3.58523 34.7272 3.58523H13.9422C14.2702 4.31165 14.4342 5.08494 14.4342 5.88166C14.4342 9.02167 11.9504 11.5993 8.85721 11.7633Z",
    fill: "#741374",
    stroke: "#741374",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6835 25.9872C19.3789 25.9872 19.1445 25.7528 19.1445 25.4482V20.7616C19.1445 20.457 19.3789 20.2227 19.6835 20.2227C19.9881 20.2227 20.2224 20.457 20.2224 20.7616V25.4482C20.2224 25.7528 19.9881 25.9872 19.6835 25.9872Z",
    fill: "#741374",
    stroke: "#741374",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4003 25.9872C25.0957 25.9872 24.8379 25.7528 24.8379 25.4482V20.7616C24.8379 20.457 25.0957 20.2227 25.4003 20.2227C25.7049 20.2227 25.9392 20.457 25.9392 20.7616V25.4482C25.9392 25.7528 25.7049 25.9872 25.4003 25.9872Z",
    fill: "#741374",
    stroke: "#741374",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5431 26.4558C17.3175 26.4558 13.0762 22.2144 13.0762 16.9889C13.0762 13.1927 15.3492 9.77154 18.8641 8.27183C19.0281 8.20153 19.2156 8.22497 19.3562 8.3187C19.5202 8.43586 19.614 8.59989 19.614 8.78736V10.7557C19.614 12.3492 20.9262 13.6614 22.5431 13.6614C24.1599 13.6614 25.4722 12.3492 25.4722 10.7557V8.78736C25.4722 8.59989 25.5659 8.43586 25.7065 8.3187C25.8705 8.22497 26.058 8.20153 26.222 8.27183C29.737 9.77154 32.01 13.1927 32.01 16.9889C32.01 22.2144 27.7686 26.4558 22.5431 26.4558ZM18.5126 9.65437C15.8413 11.1072 14.1775 13.9192 14.1775 16.9889C14.1775 21.6052 17.9268 25.3779 22.5431 25.3779C27.1594 25.3779 30.9086 21.6052 30.9086 16.9889C30.9086 13.9192 29.2215 11.1072 26.5735 9.65437V10.7557C26.5735 12.9584 24.7692 14.7628 22.5431 14.7628C20.3404 14.7628 18.536 12.9584 18.536 10.7557V9.65437H18.5126Z",
    fill: "#741374",
    stroke: "#741374",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5436 26.4558C20.1769 26.4558 17.9039 25.5653 16.1465 23.9719C16.0527 23.8782 15.9824 23.7376 15.9824 23.5735V18.348C15.9824 16.1922 17.7399 14.4113 19.8957 14.4113H21.1377C21.4189 14.4113 21.6766 14.669 21.6766 14.9736V16.0984C21.6766 16.5905 22.075 16.9654 22.5436 16.9654C23.0123 16.9654 23.4107 16.5905 23.4107 16.0984V14.9736C23.4107 14.669 23.645 14.4347 23.9496 14.4347H25.1916C27.3474 14.4347 29.1049 16.1922 29.1049 18.348V23.5735C29.1049 23.7376 29.0346 23.8782 28.9174 23.9719C27.1834 25.5653 24.9104 26.4558 22.5436 26.4558ZM17.0838 23.3392C18.5835 24.6514 20.5284 25.3544 22.5436 25.3544C24.5589 25.3544 26.5038 24.6514 28.0269 23.3392V18.348C28.0269 16.778 26.7381 15.5126 25.1916 15.5126H24.512V16.0984C24.512 17.1998 23.6216 18.0668 22.5436 18.0668C21.4657 18.0668 20.5753 17.1763 20.5753 16.0984V15.5126H19.8957C18.3491 15.5126 17.0838 16.778 17.0838 18.348V23.3392Z",
    fill: "#741374",
    stroke: "#741374",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5426 18.0668C21.4647 18.0668 20.5742 17.1764 20.5742 16.0985V13.9192C20.5742 13.7317 20.668 13.5677 20.832 13.4505C20.996 13.3568 21.1835 13.3334 21.3475 13.4271C22.0974 13.7552 22.9878 13.7552 23.7377 13.4271C23.9017 13.3334 24.0892 13.3568 24.2532 13.4505C24.4172 13.5677 24.5109 13.7317 24.5109 13.9192V16.0985C24.5109 17.1764 23.6205 18.0668 22.5426 18.0668ZM21.6756 14.669V16.0985C21.6756 16.5905 22.0739 16.9655 22.5426 16.9655C23.0112 16.9655 23.4096 16.5905 23.4096 16.0985V14.669C22.8472 14.7862 22.238 14.7862 21.6756 14.669Z",
    fill: "#741374",
    stroke: "#741374",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5422 14.7628C20.3161 14.7628 18.5117 12.9584 18.5117 10.7323V8.22499C18.5117 7.92036 18.7695 7.68604 19.0741 7.68604H26.0103C26.3149 7.68604 26.5492 7.92036 26.5492 8.22499V10.7323C26.5726 12.9584 24.7683 14.7628 22.5422 14.7628ZM19.6131 8.76395V10.7557C19.6131 12.3492 20.9253 13.6614 22.5422 13.6614C24.1591 13.6614 25.4713 12.3492 25.4713 10.7557V8.76395H19.6131Z",
    fill: "#741374",
    stroke: "#741374",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.394 8.76394H19.0741C18.7695 8.76394 18.5117 8.52961 18.5117 8.22498V6.86587C18.5117 6.23318 19.0272 5.74109 19.6365 5.74109H20.8081C21.4174 5.74109 21.9329 6.23318 21.9329 6.86587V8.22498C21.9329 8.52961 21.6752 8.76394 21.394 8.76394ZM19.6131 7.68602H20.8316V6.86587C20.8316 6.84244 20.8316 6.819 20.8081 6.819H19.6365C19.6365 6.819 19.6131 6.84244 19.6131 6.86587V7.68602Z",
    fill: "#741374",
    stroke: "#741374",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0107 8.76394H21.3944C21.0898 8.76394 20.832 8.52961 20.832 8.22498V6.86587C20.832 6.23318 21.3476 5.74109 21.9568 5.74109H25.4483C26.0576 5.74109 26.5731 6.23318 26.5731 6.86587V8.22498C26.5731 8.52961 26.3153 8.76394 26.0107 8.76394ZM21.9334 7.68602H25.4717V6.86587C25.4717 6.84244 25.4483 6.819 25.4483 6.819H21.9568C21.9568 6.819 21.9334 6.84244 21.9334 6.86587V7.68602Z",
    fill: "#741374",
    stroke: "#741374",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.783 29.01H12.2792C11.998 29.01 11.7402 28.7757 11.7402 28.4711C11.7402 28.1665 11.998 27.9087 12.2792 27.9087H32.783C33.0876 27.9087 33.3454 28.1665 33.3454 28.4711C33.3454 28.7757 33.0876 29.01 32.783 29.01Z",
    fill: "#741374",
    stroke: "#741374",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.783 32.8764H12.2792C11.998 32.8764 11.7402 32.6186 11.7402 32.314C11.7402 32.0094 11.998 31.775 12.2792 31.775H32.783C33.0876 31.775 33.3454 32.0094 33.3454 32.314C33.3454 32.6186 33.0876 32.8764 32.783 32.8764Z",
    fill: "#741374",
    stroke: "#741374",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.783 36.7194H12.2792C11.998 36.7194 11.7402 36.4851 11.7402 36.1804C11.7402 35.8758 11.998 35.618 12.2792 35.618H32.783C33.0876 35.618 33.3454 35.8758 33.3454 36.1804C33.3454 36.4851 33.0876 36.7194 32.783 36.7194Z",
    fill: "#741374",
    stroke: "#741374",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.55354 11.7633C5.3198 11.7633 2.67188 9.13884 2.67188 5.88167C2.67188 2.64792 5.3198 0.0234375 8.55354 0.0234375C11.7873 0.0234375 14.4352 2.64792 14.4352 5.88167C14.4352 9.13884 11.7873 11.7633 8.55354 11.7633ZM8.55354 1.12478C5.92905 1.12478 3.77322 3.25718 3.77322 5.88167C3.77322 8.52959 5.90562 10.662 8.55354 10.662C11.2015 10.662 13.3339 8.52959 13.3339 5.88167C13.3339 3.25718 11.2015 1.12478 8.55354 1.12478Z",
    fill: "#741374",
    stroke: "#741374",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.82006 7.66252C6.63259 7.66252 6.44513 7.56879 6.3514 7.38132L5.57811 6.04565C5.43751 5.78788 5.50781 5.43639 5.78901 5.29579C6.04677 5.15519 6.37483 5.22549 6.51543 5.50669L7.03095 6.37371L10.7802 4.19444C11.038 4.05385 11.3895 4.12415 11.5301 4.40534C11.6707 4.6631 11.6004 4.99116 11.3192 5.13176L7.10125 7.59222C7.00752 7.63908 6.91379 7.66252 6.82006 7.66252Z",
    fill: "#741374",
    stroke: "#741374",
    strokeWidth: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_126_237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitmenthome);
export default __webpack_public_path__ + "static/media/recruitmenthome.2707661a2092f44e00b7e41cb68a4a56.svg";
export { ForwardRef as ReactComponent };